/* =====================================================
Start: Custom mobile/tablet search bar behavior
===================================================== */

(function () {
  var tabletBreakpoint = 1024;

  function updateMobileScrollState() {
    // Remove mobile scroll state on desktop screens
    if (window.innerWidth > tabletBreakpoint) {
      document.body.classList.remove('mobile-scrolled');
      return;
    }

    // Add class after small scroll to adjust mobile/tablet header/search behavior
    document.body.classList.toggle('mobile-scrolled', window.scrollY > 20);
  }

  function clickRealSearchTrigger() {
    // Find and click the original theme search trigger
    var trigger = document.querySelector(
      '.wt-header__search.wt-drawer-search .wt-header__search-trigger'
    );

    if (!trigger) return;

    trigger.click();
  }

  function openSearchFromVisualBar(event) {
    var target = event.target;

    // Handle clicks on text nodes inside the custom visual search bar
    if (target && target.nodeType === 3) {
      target = target.parentElement;
    }

    if (!target || !target.closest) return;

    var visualBar = target.closest('.custom-mobile-search-bar');

    if (!visualBar) return;

    // Prevent default click behavior and open the real search drawer instead
    event.preventDefault();
    event.stopPropagation();

    clickRealSearchTrigger();
  }

  window.addEventListener('scroll', updateMobileScrollState, { passive: true });
  window.addEventListener('resize', updateMobileScrollState);
  document.addEventListener('DOMContentLoaded', updateMobileScrollState);
  document.addEventListener('click', openSearchFromVisualBar);
})();

/* =====================================================
End: Custom mobile/tablet search bar behavior
===================================================== */


/* =====================================================
Start: Normalize Arabic/Persian digits in Shopify search
Converts: ٠١٢٣٤٥٦٧٨٩ and ۰۱۲۳۴۵۶۷۸۹ to 0123456789
Purpose: Make searches like "٢" return results for "2"
===================================================== */

(function () {
  const digitMap = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
  };

  function normalizeDigits(value) {
    return value.replace(/[٠-٩۰-۹]/g, function (digit) {
      return digitMap[digit] || digit;
    });
  }

  function normalizeInput(input) {
    if (!input || !input.value) return;

    const oldValue = input.value;
    const newValue = normalizeDigits(oldValue);

    if (oldValue !== newValue) {
      const cursorPosition = input.selectionStart;
      input.value = newValue;

      if (typeof cursorPosition === 'number') {
        input.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
  }

  // Normalize while typing, useful for predictive search
  document.addEventListener('input', function (event) {
    const input = event.target;

    if (
      input.matches('input[name="q"]') ||
      input.matches('input[type="search"]')
    ) {
      normalizeInput(input);
    }
  }, true);

  // Normalize again before submitting the search form
  document.addEventListener('submit', function (event) {
    const form = event.target;
    const searchInput = form.querySelector('input[name="q"]');

    if (searchInput) {
      normalizeInput(searchInput);
    }
  }, true);

  // If user opens /search?q=٢ directly, redirect it to /search?q=2
  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const currentQuery = params.get('q');

    if (!currentQuery) return;

    const normalizedQuery = normalizeDigits(currentQuery);

    if (currentQuery !== normalizedQuery) {
      params.set('q', normalizedQuery);
      window.location.replace(
        window.location.pathname + '?' + params.toString()
      );
    }
  });
})();

/* =====================================================
End: Normalize Arabic/Persian digits in Shopify search
===================================================== */